import styles from "./tooltip.module.css"
import React from "react"
import { formatDate } from "../MonitorSlice"
import { Box, Typography } from "@mui/material"

export const StandardTooltipContent: React.FC<{
  task: any
  fontSize: string
  fontFamily: string
}> = ({ task, fontSize, fontFamily }) => {
  const style = {
    fontSize,
    fontFamily,
  }
  return task.type == "task" && !task.showToolTip ? (
    <Box className={styles.tooltipDefaultContainer} sx={style}>
      <Typography
        variant={"caption"}
        sx={{ fontSize: fontSize + 6 }}
      >{`${task.toolTipName}`}</Typography>

      <p className={styles.tooltipDefaultContainerParagraph}>{`Start Time: ${
        // formatDate(task.start.toISOString())
        formatDate(task.start.toISOString())
      }`}</p>
      <p className={styles.tooltipDefaultContainerParagraph}>{`End Time: ${
        // formatDate(task.start.toISOString())
        formatDate(task.end.toISOString())
      }`}</p>

      <p className={styles.tooltipDefaultContainerParagraph}>
        {!!task.progress && `Progress: ${task.progress} %`}
      </p>
    </Box>
  ) : (
    ""
  )
}
